import Create from './Create';
import Edit from './Edit'
import List from './List';

const resource = {
    list: List,
    create: Create,
    edit: Edit,
};

export default resource;